import { render } from "./FormInputError.vue?vue&type=template&id=1fad167f&scoped=true&ts=true"
import script from "./FormInputError.vue?vue&type=script&lang=ts"
export * from "./FormInputError.vue?vue&type=script&lang=ts"

import "./FormInputError.vue?vue&type=style&index=0&id=1fad167f&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fad167f"]])

export default __exports__